import { HTTP } from "../axios";

export default {
  logout: ({ commit }) => {
    commit("clear_user_data");
  },
};



// WEBPACK FOOTER //
// ./src/store/actionsApi.js